export default __webpack_public_path__ + "static/media/banner-inner.5b029177.jpg";